import React, { useCallback, useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL FUNCTIONS
import { makePath } from 'functions';

// CORE COMPONENTS
import Form from 'core/form/Form';

// VARIABLES
const DOCUMENT_TYPES = {
  factoryProgram: {
    id: 1,
    code: 'Factory Program'
  },
  customerSig: {
    id: 2,
    code: 'Customer Signature Form'
  }
}

// MAIN COMPONENT
const CustomerRebatesAttachment = ({
  documentType,
  ...props
}) => {

  // FORMIK
  const { values } = useFormikContext() || {};

  // MEMOS
  const {
    dealer_rebate_id,
    rebate_title,
    disabled = !dealer_rebate_id && !rebate_title
  } = useMemo(
    () => values || {},
    [values]
  )

  const handleUploadMeta = useCallback((data) => ({
    fileName: data.fileName || data.rebateattachment_filename,
    uploadedBy: data.updated_by || data.created_by || data.uploadedBy,
    uploadedOn: data.date_updated || data.date_created || data.timecreated
  }), []);

  // RENDER
  return (
    <Form.Upload
      uploadArgs={(_uploadID, file) => {
        const params = {
          documentType: DOCUMENT_TYPES[documentType]?.id,
          fileName: file.name
        }
        if (dealer_rebate_id) {
          params.dealerRebateId = dealer_rebate_id;
        } else if (rebate_title) {
          params.dealerRebateTitle = rebate_title;
        }
        return {
          endpoint: ENDPOINTS.uploads.rebate.temp,
          params
        }
      }}
      deleteArgs={(_uploadID, _file, _meta, fieldValue) => ({
        method: 'DELETE',
        endpoint: fieldValue.rebateattachment_id ? makePath(ENDPOINTS.uploads.rebate.delete(dealer_rebate_id), fieldValue.rebateattachment_id) : undefined
      })}
      viewArgs={(_uploadID, _file, _meta, fieldValue) => ({
        endpoint: fieldValue.rebateattachment_id ? makePath(ENDPOINTS.uploads.rebate.view(dealer_rebate_id), fieldValue.rebateattachment_id) : undefined
      })}
      uploadFieldValue={({ created_by_site_user_id, message, status, ...data }) => [data]}
      uploadMeta={handleUploadMeta}
      disabled={disabled}
      text={disabled && 'You must enter Rebate Program Name (Title) before you can upload a file.'}
      {...props}
    />
  )
}
// EXPORT
export default CustomerRebatesAttachment
